// extracted by mini-css-extract-plugin
export default {"hireChefMianBtn":"Navbar_hireChefMianBtn__JuYHJ"};